module.exports = __webpack_public_path__ + "static/media/shield-cross.946db915.svg";